
const VARIANT_CLASS = {
  primary: 'btn primary',
  secondary: 'btn secondary',
  ghost: 'btn ghost',
  link: 'linkbtn',
};
  
const Button = ({
  variant = 'primary',
  block = false,
  loading = false,
  disabled = false,
  type = 'button',
  className = '',
  children,
  ...rest
}) => {
  const base = VARIANT_CLASS[variant] || VARIANT_CLASS.primary;
  const isBtn = variant !== 'link';

  const classes = [base, block && isBtn ? 'block' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      {...rest}
    >
      {loading && <span className="spin" />}
      {children}
    </button>
  );
};

export default Button;
